import { render } from "./GrammarTemplate.vue?vue&type=template&id=8485b5cc&scoped=true"
import script from "./GrammarTemplate.vue?vue&type=script&lang=js"
export * from "./GrammarTemplate.vue?vue&type=script&lang=js"

import "./GrammarTemplate.vue?vue&type=style&index=0&id=8485b5cc&scoped=true&lang=css"
import "./GrammarTemplate.vue?vue&type=style&index=1&id=8485b5cc&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8485b5cc"]])

export default __exports__